import { render } from "./ListReports.vue?vue&type=template&id=768cabaa"
import script from "./ListReports.vue?vue&type=script&lang=js"
export * from "./ListReports.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/views/customer/reporting/process/list_reports.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fcustomer%2Freporting%2Fprocess%2FListReports.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/models/container.yml?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fcustomer%2Freporting%2Fprocess%2FListReports.vue&lang=yaml"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__